import { css } from 'styled-components/macro'

export const baseGlobalStyles = css`
  html,
  body {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`
